import 'babel-polyfill';

import Vue from 'vue';
import App from './App';

import router from '@/app/router';
import store from '@/app/store';
import VuexRouterSync from 'vuex-router-sync';

import Axios from 'axios';

VuexRouterSync.sync( store, router );

Axios.defaults.baseURL = window._rootData.apiUrl;
Axios.defaults.headers.common.Accept = 'application/json';
Axios.interceptors.response.use(
    response => response,
    ( error ) =>
    {
        return Promise.reject( error );
    }
);

Vue.$http = Axios;
Object.defineProperty( Vue.prototype, '$http', {
    get()
    {
        return Axios;
    }
});

let klantNr = window._rootData.klantNr;
if( klantNr === 'null' )
{
    klantNr = null;
}

let klantNaam = window._rootData.klantNaam;
if( klantNaam === 'null' )
{
    klantNaam = null;
}

store.dispatch( 'entry/merge', {
    formVersion: window._rootData.formAB || 'A',
    klantNr: klantNr,
    klantNaam: klantNaam
});

Vue.config.productionTip = false;
window.dataLayer = window.dataLayer || [];

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});
